import { useEffect, useRef } from "react";

interface Props {
  open: boolean;
  onClose: () => void;
}

export function HowTo({ open, onClose }: Props) {
  const ref = useRef<HTMLDialogElement>(null);

  useEffect(() => {
    const dialog = ref.current;
    if (!dialog) return;
    if (open && !dialog.open) dialog.showModal();
    if (!open && dialog.open) dialog.close();
  }, [open]);

  return (
    <dialog className="howto" ref={ref} aria-labelledby="howtoTitle" onClose={onClose}>
      <h2 id="howtoTitle">Cómo se juega</h2>
      <ol>
        <li>Lee la pista: un estadio, un partido, un jugador…</li>
        <li>Gira el globo y toca donde crees que ocurrió. Confirma tu pin.</li>
        <li>Cuanto más cerca, más puntos (hasta 100 por pista). Comparte tu resultado.</li>
      </ol>
      <form method="dialog">
        <button className="cta">Entendido</button>
      </form>
    </dialog>
  );
}
